// extracted by mini-css-extract-plugin
export default {"burgerMenu":"BurgerMenu_burgerMenu__Na7UV","burgerMenuLine":"BurgerMenu_burgerMenuLine__goRmL","burgerMenuToggled":"BurgerMenu_burgerMenuToggled__pUacL"};